import React from 'react';
import { FormattedMessage } from 'react-intl';

import { purchaseOrderGridProperties } from '../../data/purchase-order-properties';
import { messages } from '../messages';

const name = <FormattedMessage {...messages.referenceNumberColumnHeader} />;

/**
 * Reference Number column configuration
 * Displays the reference number for the purchase order
 * @type {import('./types').GridColumn} Column configuration object
 */
export const referenceNumberColumn = {
  name,
  render: (data) => data.referenceNumber,
  id: purchaseOrderGridProperties.referenceNumber,
};
